<template>
    <div>
        <CardBase class="px-4 py-4">
            <div class="text-lg border-b border-gray-400">{{ $t('component.coronaInfo.dialog.title') }}</div>
            <div class="mt-4 text-sm">{{ $t('component.coronaInfo.dialog.section1') }}</div>

            <object class="mt-2" height="650" width="100%" type="application/pdf" :data="pdf">
                <p class="text-red-600">PDF cannot be displayed.</p>
            </object>

            <div class="mt-2 text-sm">{{ $t('component.coronaInfo.dialog.section2') }}</div>
            <div class="mt-2 text-sm">{{ $t('component.coronaInfo.dialog.section3') }}</div>
            <div class="mt-2 text-sm">{{ $t('component.coronaInfo.dialog.section4') }}</div>
        </CardBase>
    </div>
</template>

<script>
    import coronaPlakatPdf from "@/../public/PLAKAT-OGO_LNY.pdf";
    import CardBase from "@/components/shared/CardBase";

    export default {
        name: "Corona",
        components: {CardBase},
        data() {
            return {
                pdf: coronaPlakatPdf
            }
        }
    }
</script>

<style scoped>

</style>